import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Heading from '@bibliocommons/heading';
import { ExpandableList } from '@bibliocommons/expandable';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import { bibMetadataEventComposer } from '@bibliocommons/analytics-event-composers';
import AnalyticsConstants from '@bibliocommons/constants-analytics';
import FieldValue from 'app/components/bibs/shared/MetadataDisplay/FieldValue';
import './Contains.scss';

const MAX_ITEMS_DISPLAYED = 3;

const { composeMetadataLinkClickEvent, composeShowMoreEvent } = bibMetadataEventComposer;
const { CUSTOM_DIMENSIONS } = AnalyticsConstants;

function handleClickEvent() {
  sendAnalyticsEvents(
    composeMetadataLinkClickEvent({
      fieldName: 'CONTAINS_WORK',
      category: 'CONTAINS',
      gtmContainerName: CUSTOM_DIMENSIONS.CONTAINER_NAMES.BIB_ABOUT
    })
  );
}

function handleShowMoreEvent(expanded) {
  sendAnalyticsEvents(composeShowMoreEvent({ expanded }));
}

export default function Contains({ containedWork }) {
  if (!containedWork || !containedWork.size) return null;

  function renderItems() {
    const renderWork = work => <FieldValue value={work} handleClick={handleClickEvent} />;
    const getItemKey = item => item.getIn(['primary', 'values', 0]);

    return (
      <ExpandableList
        list={containedWork}
        getItemKey={getItemKey}
        renderItem={renderWork}
        collapseCount={MAX_ITEMS_DISPLAYED}
        expandLinkHref="#show-more-contains"
        handleToggle={handleShowMoreEvent}
        stacked
        textKey="contains"
      />
    );
  }

  return (
    <div className="cp-contains">
      <Heading tagName="h3" size="medium" variant>
        <FormattedMessage id="bib_metadata_category_contains" />
      </Heading>
      {renderItems()}
    </div>
  );
}

Contains.propTypes = {
  containedWork: ImmutablePropTypes.listOf(ImmutablePropTypes.map)
};
